import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Cifrado } from 'src/app/libraries/cifrado/cifrado';
import { GVars } from 'src/app/system/gvars/gvars';
import { Usuario } from 'src/app/models/usuario/usuario';
import { Documento } from 'src/app/models/documento/documento';
import { DocumentoCategoria } from 'src/app/models/documento/documentoCategoria';
import { Libro } from 'src/app/models/libro/libro';
import { Curso } from 'src/app/models/curso/curso';
import { LibroCategoria } from 'src/app/models/libro/libroCategoria';
import { CursoCategoria } from 'src/app/models/curso/cursoCategoria';


@Injectable({
  providedIn: 'root'
})
export class KnCloudRestApiService {
  private cifrado: Cifrado;
  private urlServiceApi: string;

  constructor(
    private http: HttpClient,
    public  gVars: GVars) 
  {
    this.cifrado = new Cifrado();
    //this.urlServiceApi = 'http://127.0.0.1:8000/api';
    this.urlServiceApi = 'http://efeso.com.ar/biblioteca-ws/api';
  }

  crearDocumento(documento: Documento) 
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = {
      "titulo": documento.titulo,      
      "descripcion": documento.descripcion,
      "autor": documento.autor,
      "categoria_id": documento.categoria_id,
      "estado": documento.estado
    }

    return this.http.post(this.urlServiceApi + '/documento/crearDocumento/' + token, JSON.stringify(data), httpOptions);
  }

  listarDocumentos() 
  {
    let rn = Math.floor(Math.random() * 1000) + 1 ;
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/documento/listarDocumentos/' + token + '?rn=' + rn;
    console.log(request);
    return this.http.get(request);
  }

  subirImagenDocumento(file: any, id: number) 
  {
    let token = this.cifrado.generarToken();
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.urlServiceApi + '/documento/subirImagen/' + token + '/' + id, formData);
  }

  subirDocumentoPdf(file: any, id: number) 
  {
    let token = this.cifrado.generarToken();
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.urlServiceApi + '/documento/subirDocumentoPdf/' + token + '/' + id, formData);
  }

  crearDocumentoCategoria(documentoCategoria: DocumentoCategoria)
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = {
      "nombre": documentoCategoria.nombre,
      "estado": documentoCategoria.estado
    }

    return this.http.post(this.urlServiceApi + '/documento/crearDocumentoCategoria/' + token, JSON.stringify(data), httpOptions);
  }

  listarDocumentosCategorias() 
  {
    let rn = Math.floor(Math.random() * 1000) + 1 ;
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/documento/listarDocumentosCategorias/' + token + '?rn=' + rn;
    console.log(request);
    return this.http.get(request);
  }

  /* Cursos */
  crearCurso(curso: Curso) 
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = {
      "titulo": curso.titulo,      
      "descripcion": curso.descripcion,
      "autor": curso.autor,
      "categoria_id": curso.categoria_id,
      "lecciones": curso.lecciones,
      "link": curso.link,
      "estado": curso.estado
    }

    return this.http.post(this.urlServiceApi + '/curso/crearCurso/' + token, JSON.stringify(data), httpOptions);
  }

  editarCurso(curso: Curso) 
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = {
      "titulo": curso.titulo,      
      "descripcion": curso.descripcion,
      "autor": curso.autor,
      "categoria_id": curso.categoria_id,
      "lecciones": curso.lecciones,
      "link": curso.link,
      "estado": curso.estado
    }

    return this.http.post(this.urlServiceApi + '/curso/editarCurso/' + token + '/' + curso.id, JSON.stringify(data), httpOptions);
  }

  obtenerCurso(id: number) 
  {
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/curso/obtenerCurso/' + token + '/' + id;
    console.log(request);
    return this.http.get(request);
  }
  
  listarCursos() 
  {
    let rn = Math.floor(Math.random() * 1000) + 1 ;
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/curso/listarCursos/' + token + '?rn=' + rn;
    console.log(request);
    return this.http.get(request);
  }

  subirImagenCurso(file: any, id: number) 
  {
    let token = this.cifrado.generarToken();
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.urlServiceApi + '/curso/subirImagen/' + token + '/' + id, formData);
  }

  crearCursoCategoria(cursoCategoria: CursoCategoria)
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = {
      "nombre": cursoCategoria.nombre,
      "estado": cursoCategoria.estado
    }

    return this.http.post(this.urlServiceApi + '/curso/crearCursoCategoria/' + token, JSON.stringify(data), httpOptions);
  }

  editarCursoCategoria(cursoCategoria: CursoCategoria) 
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = {
      "nombre": cursoCategoria.nombre,
      "estado": cursoCategoria.estado
    }
    console.log(this.urlServiceApi + '/curso/editarCursoCategoria/' + token + "/" + cursoCategoria.categoria_id);
    return this.http.post(this.urlServiceApi + '/curso/editarCursoCategoria/' + token + "/" + cursoCategoria.categoria_id, JSON.stringify(data), httpOptions);
  }

  obtenerCursoCategoria(id: number) 
  {
    let rn = Math.floor(Math.random() * 1000) + 1 ;
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/curso/obtenerCursoCategoria/' + token + '/' + id;
    console.log(request);
    return this.http.get(request);
  }

  listarCursosCategorias() 
  {
    let rn = Math.floor(Math.random() * 1000) + 1 ;
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/curso/listarCursosCategorias/' + token + '?rn=' + rn;
    console.log(request);
    return this.http.get(request);
  }

  /* Libros */
  crearLibro(libro: Libro)
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = {
      "titulo": libro.titulo,      
      "descripcion": libro.descripcion,
      "autor": libro.autor,
      "editorial": libro.editorial,
      "categoria_id": libro.categoria_id,
      "formato": libro.formato,
      "link": libro.link,
      "estado": libro.estado
    }

    return this.http.post(this.urlServiceApi + '/libro/crearLibro/' + token, JSON.stringify(data), httpOptions);
  }
  
  listarLibros() 
  {
    let rn = Math.floor(Math.random() * 1000) + 1 ;
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/libro/listarLibros/' + token + '?rn=' + rn;
    console.log(request);
    return this.http.get(request);
  }

  subirImagenLibro(file: any, id: number) 
  {
    let token = this.cifrado.generarToken();
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.urlServiceApi + '/libro/subirImagen/' + token + '/' + id, formData);
  }

  crearLibroCategoria(libroCategoria: LibroCategoria)
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = {
      "nombre": libroCategoria.nombre,
      "estado": libroCategoria.estado
    }

    return this.http.post(this.urlServiceApi + '/libro/crearLibroCategoria/' + token, JSON.stringify(data), httpOptions);
  }

  listarLibrosCategorias() 
  {
    let rn = Math.floor(Math.random() * 1000) + 1 ;
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/libro/listarLibrosCategorias/' + token + '?rn=' + rn;
    console.log(request);
    return this.http.get(request);
  }

  obtenerUsuario(email: string) 
  {
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/usuario/obtenerUsuario/' + token + '/' + email;
    console.log(request);
    return this.http.get(request);
  }

  crearUsuario(usuario: Usuario) 
  {  
    let token = this.cifrado.generarToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }

    let data = 
    {
      'nombre': usuario.nombre,
      'apellido': usuario.apellido,
      'telefono': usuario.telefono,
      'direccion': usuario.direccion,
      'email': usuario.email,
      'password': this.cifrado.generarMd5(usuario.password),
      'administrador': 0,
      'estado': 1
    }

    //console.log(JSON.stringify(data));
    return this.http.post(this.urlServiceApi + '/usuario/crearUsuario/' + token, JSON.stringify(data), httpOptions);
  }

  listarUsuarios()
  {
    let rn = Math.floor(Math.random() * 1000) + 1 ;
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/usuario/listarUsuarios/' + token + '?rn=' + rn;
    //console.log(request);
    return this.http.get(request);
  }

  cambiarPasswordUsuario(email: string, passwordNuevo: string)
  {
    let token = this.cifrado.generarToken();
    let request = this.urlServiceApi + '/usuario/cambiarPassword/' + token + '/' + email + '/' + passwordNuevo;
    //console.log(request);
    return this.http.get(request);
  }
}
